import { Controller } from "../../../Controller";
import {
    AtualizarConfigEnvelopeDocumentoService,
    DeletarConfigEnvelopeDocumentoService,
    GetConfigEnvelopeDocumentoService,
    InserirConfigEnvelopeDocumentoService,
    ListarConfigEnvelopeDocumentoService,
} from "../../../../Services/Geral/ConfigEnvelope/ConfigEnvelopeDocumento/ConfigEnvelopeDocumentoServices";
import { IInserirConfigEnvelopeDocumento } from "../../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeDocumento/ConfigEnvelopeDocumentoInterfaces";

export async function GetConfigEnvelopeDocumentoController(
    idConfigEnvelopeDoc: number
) {
    return Controller(GetConfigEnvelopeDocumentoService(idConfigEnvelopeDoc));
}

export async function ListarConfigEnvelopeDocumentoController(
    idConfigEnvelope: number
) {
    return Controller(ListarConfigEnvelopeDocumentoService(idConfigEnvelope));
}

export async function InserirConfigEnvelopeDocumentoController(
    configEnvelope: IInserirConfigEnvelopeDocumento
) {
    return Controller(InserirConfigEnvelopeDocumentoService(configEnvelope));
}

export async function DeletarConfigEnvelopeDocumentoController(
    idConfigEnvelope: number
) {
    return Controller(DeletarConfigEnvelopeDocumentoService(idConfigEnvelope));
}

export async function AtualizarConfigEnvelopeDocumentoController(
    configEnvelope: IInserirConfigEnvelopeDocumento
) {
    return Controller(AtualizarConfigEnvelopeDocumentoService(configEnvelope));
}
